import classNames from 'classnames'
import React from 'react'

import { CommonTemplateSidePanel } from '../CommonTemplate/CommonTemplateSidePanel'
import { SidePanelContentProps } from '../CommonTemplate/types'
import { wixStudioTemplateDataHooks } from './WixStudioTemplate.dataHooks'
import s from './WixStudioTemplateSidePanel.scss'

export const WixStudioTemplateSidePanel: React.FC<SidePanelContentProps> = props => (
  <CommonTemplateSidePanel
    dataHook={wixStudioTemplateDataHooks.sidePanel()}
    {...props}
    className={classNames(s.WixStudioTemplateSidePanel, props.className)}
    content={
      // mapped content if content exists
      (props.content?.length &&
        props.content?.map(c => ({
          items: c?.content?.items.items || [],
          background: c?.content?.background || '#000624',
          color: c?.content?.color || '#ffffff',
        }))) ||
      // default content if no children passed
      (!props.children && [
        {
          items: [],
          background: '#000624',
          color: '#ffffff',
        },
      ]) ||
      // no content otherwise - fully custom side panel contents
      []
    }
  />
)
